import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-info-success',
  templateUrl: './info-success.component.html',
  styleUrls: ['./info-success.component.css']
})
export class InfoSuccessComponent implements OnInit {

  @Input() contenu:string;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    setTimeout(() => {
      this.activeModal.dismiss();
    }, 3000);
  }

}
